import React, {useRef, useState} from "react";
import styled from "styled-components";

import firebase from "firebase";

import { withNamespaces } from 'react-i18next';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: ${({width = '820px'}) => `${width}`};
  border-radius: ${({borderRadius = '20px'}) => borderRadius};
  padding: ${({padding = '25px'}) => padding};
  margin-left: auto;
  margin-right: auto;

  .main-widget-content {
    width: 100%;
    position: relative;
    overlow: hidden;
    margin-bottom: 10px;

    .content.hide {
      opacity: 0;
    }
  }

  .main-widget-content.wSub {
    margin-bottom: 0;
  }

  .title {
    margin-bottom: 11px;
    text-transform: uppercase;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 20px;
    letter-spacing: 0.01em;
  }

  .subtitle {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
    letter-spacing: 0.01em;
  }

  .progressBar {
    margin-top: 16px;
    width: 100%;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    letter-spacing: 0.01em;

    .count-info {
      display: flex;
      justify-content: space-between;
    }

    progress {
      border: none;
      width: 100%;
      height: 8px;
      background: rgba(191, 191, 191, 0.4);
      border-radius: 2px;
      transition: .5s;
    }
    
    progress {
      color: rgba(191, 191, 191, 0.4);
      border-radius: 2px;
    }
    
    progress::-webkit-progress-value {
      background: #DD26E4;
      border-radius: 2px;
      transition: .5s;
    }
    
    progress::-moz-progress-bar {
      background: #DD26E4;
      border-radius: 2px;
    }
    
    progress::-webkit-progress-value {
      background: #DD26E4;
      border-radius: 2px;
    }
    
    progress::-webkit-progress-bar {
      background: rgba(191, 191, 191, 0.4);
      border-radius: 2px;
    }
  }

  .mode-payment {
    margin-top: 34px;
    width: 100%;
    display: flex;

    .tab {
      display: flex;
      flex: 1 1;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      justify-content: center;
      padding-bottom: 10px;
      border-bottom: 2px solid #C4C4C4;
      cursor: pointer;
    }

    .tab.selected {
      border-bottom: 4px solid #15C67C;
    }
  }

  .select {
    margin-top: 34px;
    text-align-last: center;
    text-align: center;
    font-weight: bold;
    background: transparent;
    background-image: url("data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgBpdLLDcMgDAZgHgvkitgC2KvdIM4GHam99YAYA8agdkWltkl4JL9kJIz5xAFurb3knKcQwsJOpDhc0IIBY8zMDqbcvQkhJplSemqtOTZAKcVw/xjF6EFYi/ceJDVjjPcj6D9GPfk5HEW3sB9wBN3DVmAPWsM2wRrawiicVeKcA/xWMxa8hxtYE/xGC1jFukMo1rVn9gVxVXXAPxIXmwAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 19px;
    color: #333333;
    margin-bottom: 12px;
    width: 100%;
    min-width: 184px;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: 16px;
    border: 1px solid ${({invertColor = '#A1A1A1'}) => invertColor};
    border-radius: ${({borderRadius = '6px'}) => borderRadius};
    cursor: pointer;
  }

  .select-gratuity {
    text-align-last: start;
    text-align: start;
  }

  .defined-prices-container {
    width: calc(100% + 12px + 38px);
    margin-left: -25px;
    padding: 0 19px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 6px;

    .defined-price {
      margin: 6px;
      padding: 15px 19px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid ${({invertColor = '#A1A1A1'}) => invertColor};
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      font-size: 18px;
      line-height: 20px;
      color: #333333;
      flex: 1 1;
    }

    .defined-price.picked {
      background-color: #19FF9F;
    }
  }

  .input-donation {
    margin-bottom: 5px;
    width: 100%;

    input {
      width: 100%;
      padding: 16px 16px 16px 80px;
      font-weight: 600;
      font-size: 46px;
      border: 1px solid ${({invertColor = '#A1A1A1'}) => invertColor};
      border-radius: ${({borderRadius = '6px'}) => borderRadius};
      font-weight: bold;
      text-align: end;
      color: #333333;
    }

    input::placeholder {
      color: #BDBDBD;
    }

    label {
      font-weight: bold;
      text-align: end;
      color: #333333;  
      font-weight: 600;
      font-size: 46px;
      position: absolute;
      padding: 16px;
    }

    span {
      font-weight: normal;
      font-size: 12px;
      line-height: 20px;
      text-align: right;
      width: 100%;
      display: block;
      color: #F91313;
      opacity: 1;
    }

    span.hide {
      opacity: 0;
    }
  }

  .input-donation.invalid input {
    border-color: #F91313;
  }

  .help-bysol {
    span {
      font-weight: 700;
      letter-spacing: 0.01em;
      font-size: 14px;
      line-height: 20px;
      color: #333333;
    }

    p {
      color: #777777;
      margin-top: 8px;
      color: #333333;
      font-size: 11px;
      line-height: 18px;

      strong {
        color: #333333;
      }
    }
  }

  .total-check {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    font-weight: bold;
  }

  .check-pay {
    margin-top: 24px;
    margin-bottom: 30px;
    width: 100%;
    padding-top: 20px;
    border-top: 1px solid #A1A1A1;
    font-size: 14px;

    .check-pay-title {
      font-weight: bold;]
      line-height: 17px;
      letter-spacing: 0.01em;
    }

    .check-pay-items {
      margin-top: 14px;

      .item {
        display: flex;
        justify-content: space-between;
        margin-top: 4px;
      }

      .item:first-child {
        margin-top: 0;
      }
    }
  }

  .total-charge-container {
    width: 100%;
    margin-bottom: 20px;

    .total-charge {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.01em;
    }

    .text-cancel-subscription {
      margin-top: 10px;
      font-size: 11px;
      line-height: 13px;
      letter-spacing: 0.01em;
      color: #9C9A9A;
      display: block;
      opacity: 1;
    }

    .text-cancel-subscription.hide,
    .total-charge.hide {
      opacity: 0;
    }
  }

  .confirm-btn {
    padding: 12px 56px;
    background-color: #19FF9F;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
    font-weight: bold;
    border-radius: 60px;
    cursor: pointer;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .confirm-btn:disabled {
    opacity: .8;
    cursor: no-drop;
  }

  .preview {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 20;

    .confirm-title {
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      letter-spacing: 0.01em;
    }

    .confirm-price {
      font-weight: 600;
      font-size: 40px;
      line-height: 49px;
      text-align: center;
      letter-spacing: 0.01em;
      color: #333333;
      margin: 25px 0 34px 0;

      span {
        font-size: 18px;
        font-weight: 600;
      }
    }

    .cancel-subsription-info-text {
      font-size: 11px;
      line-height: 13px;
      letter-spacing: 0.01em;
      color: #9C9A9A;
    }
  }

  .hide-preview {
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.01em;
    text-decoration-line: underline;
    color: #DD26E4;
    margin-bottom: 16px;
    position: absolute;
    bottom: 0;
    cursor: pointer;
  }

  .hide-preview:disabled {
    cursor: no-drop;
  }

  .stripe-card {
    display: block;
    margin-top: 24px;
    width: 150px;
  }
`

const currenciesReduceOptions = (acc, val) => {
  if(Array.isArray(val) && val.length === 3){
      const [value, label, char] = val;
      return [...acc, {value, label, char}]
  }
  return acc;
};

const gratuitiesReduceOptions = (acc, val) => {
  const [value, label] = val;
  return [...acc, {value, label}]
}

const DonationFormV2 = ({
  t,
  title = t("donation_form_title"),
  subtitle = t("donation_form_subtitle"),
  progressBarCollected = t("progress_bar_collected"),
  progressBarOf = t("progress_bar_of"),
  customPriceLabel = t("donation_form_customPriceLabel"),
  submit = t("donation_form_submit"),
  confirmTitle = t('confirm_title'),
  donationForTeam = t('donation_for_team'),
  donationForTeamText = t('donation_for_team_text'),
  checkTitle = t('check-title'),
  checkItemsDonation = t('check-items-donation'),
  checkItemsHelpDonation = t('check-items-help-bysol'),
  checkTotal = t('check-total'),
  confirmButtonSubmitLoading = t('confirm_button_submit_loading'),
  confirmButtonChangeValue = t('confirm_button_change_value'),
  minimumPriceDonation = t('minimum_input_donation'),
  totalChargeMonthText = t('total-charge-month-text'),
  totalChargeModeSupscription = t('total-charge-mode-supscription'),
  modePaymentTab = t('mode-payment-tab'),
  modeSubscriptionTab = t('mode-subscription-tab'),
  confirmCancelSubscriptionInfoText = t('confirm-cancel-subscription-info-text'),
  
  currencies = [
    ['eur', t("curr_eur"), '€'], 
    ['usd', t("curr_usd"), '$'],     
    ['rub', t("curr_rub"), '₽'], 
    ['gbp', t("curr_gbp"), '£'], 
    ['chf', t("curr_chf"), '₣'], 
    ['aud', t("curr_aud"), 'AU$'], 
    ['cad', t("curr_cad"), 'CA$']
  ],
  gratuities = [
    [0, t("donation_for_team_option_none_gratuity")],
    [10, "10%"],
    [15, "15%"],
    [20, "20%"],
  ],

  definedPrices = [20, 50, 75, 100, 150, 200, 300, 500],
  
  minimalPrice = 5,

  onPriceSubmit = () => null,
  ...props}) => {
    const { mbucket, forteam, withSub, hideDefinedPrices, showSB, modeDefault, subOnly, showPB } = props;

    const [modePayment, setModePayment] = useState("payment"); // payment || subscription

    const [donation, setDonation] = useState(0); // сам донат
    const [changedDonationInput, setChangedDonationInput] = useState(false);

    const currenciesOptions = currencies.reduce(currenciesReduceOptions, []);
    const gratuitiesOptions = gratuities.reduce(gratuitiesReduceOptions, []);

    const [currency, setCurrency] = useState(currenciesOptions[0].value);
    const [gratuity, setGratuity] = useState(gratuitiesOptions[0].value); // чаевые для bysol
    const [currencyChar, setCurrencyChar] = useState(currenciesOptions[0].char);

    const [viewPreview, setViewPreview] = useState(false);

    const [goalProgressBar, setGoalProgressBar] = useState(0);
    const [valueProgressBar, setValueProgressBar] = useState(0);

    const inputRef = useRef();

    const validDonation = donation === true || donation >= minimalPrice;
    const isSubmit = validDonation;

    const [loading, setLoading] = useState(false);

    if (modeDefault && modePayment !== modeDefault && withSub) {
      setModePayment(modeDefault);
    }

    if (modePayment !== "subscription" && subOnly && !withSub) {
      setModePayment("subscription");
    }

    console.log(modePayment);

    const onChangeCurrencyList = (e) => {
      const value = e.target.value.split("-")
      setCurrency(value[0]);
      setCurrencyChar(value[1]);
    }

    document.onkeydown = function(event) {
      const keyCode = event ? (event.which ? event.which : event.keyCode) : event.keyCode;
      if(keyCode === 13) {
          if (isSubmit) {
            // onPriceSubmit({donation, currency, modePayment});
            if (viewPreview) {
              setLoading(true);
              onPriceSubmit({donation, currency, mode: modePayment});
            } else {
              setViewPreview(true);
            }
          }
      }
    }

    const putProgressBar = (value, goal) => {
      setValueProgressBar(Math.floor(value));
      setGoalProgressBar(goal);
    }

    if (mbucket) {
      firebase.firestore().collection('buckets')
      .where('name', '==', mbucket).onSnapshot(function(querySnapshot) {
        const docs = querySnapshot.docs;
        const bucketsData = docs.map((doc) => doc.data())[0];
        
        if (bucketsData) {
          putProgressBar(bucketsData.value, bucketsData.goal);
        }
      });
    }

    return (
        <Wrapper className={'donation-module'} {...props}>
            <h1 className={'title'}>{title}</h1>
            <h2 className={'subtitle'}>{subtitle}</h2>
            <div className={`main-widget-content ${withSub ? "wSub" : ""}`}>
              {viewPreview && (
                <div className={'preview'}>
                  <span className={'confirm-title'}>{confirmTitle}</span>
                  <h2 className={'confirm-price'}>{currencyChar} {donation} {modePayment === "subscription" && (
                    <>
                      / <span>{totalChargeMonthText}*</span>
                    </>
                  )}</h2>
                  {modePayment === "subscription" && (
                     <p className={'cancel-subsription-info-text'}>{confirmCancelSubscriptionInfoText}</p>
                  )}
                  {viewPreview && (
                    <button disabled={loading} className={'hide-preview'} onClick={() => setViewPreview(false)}>
                      {confirmButtonChangeValue}
                    </button>
                  )}
                </div>
              )}
              <div className={`content ${viewPreview ? 'hide' : ''}`}>
                {showPB && (
                  <div className={'progressBar'}>
                    <div className={'count-info'}>
                      <span>{progressBarCollected}:</span>
                      <span>{currenciesOptions[0].char}{valueProgressBar} {progressBarOf} {goalProgressBar}</span>
                    </div>
                    <progress value={valueProgressBar} max={goalProgressBar}/>
                  </div>
                )}
                {withSub && (
                  <div className={'mode-payment'}>
                    <div 
                      className={`tab ${modePayment === "payment" ? "selected" : ""}`}
                      onClick={() => setModePayment("payment")}
                    >
                      {modePaymentTab}
                    </div>
                    <div 
                      className={`tab ${modePayment === "subscription" ? "selected" : ""}`}
                      onClick={() => setModePayment("subscription")}
                    >
                      {modeSubscriptionTab}
                    </div>
                  </div>
                )}
                <select 
                  className={'select select-currencies'} 
                  onChange={onChangeCurrencyList}
                >
                    {currenciesOptions.map((cur, index) => {
                      return (
                        <option 
                          // selected={cur.value === currency} 
                          key={index} 
                          value={`${cur.value}-${cur.char}`}
                        >
                          {cur.label}
                        </option>
                      )
                    })}
                </select>
                {!hideDefinedPrices && (
                  <div className={'defined-prices-container'}>
                    {definedPrices.map((price, index) => {
                      return <button
                        className={`defined-price ${donation === price ? 'picked' : ''}`}
                        key={`${price}-${index}`}
                        onClick={() => setDonation(price)}
                      >
                        {currencyChar}{price}
                      </button>
                    })}
                  </div>
                )}
                <div className={`input-donation ${!validDonation && changedDonationInput ? "invalid" : ""}`}>
                  <label>{currencyChar}</label>
                  <input
                    type="number"
                    placeholder="0"
                    required
                    onChange={(e) => {
                      setDonation(parseInt(e.target.value) || 0);
                      setChangedDonationInput(true);
                    }}
                    value={donation || ""}
                    min={minimalPrice}
                  />
                  <span 
                    className={`${validDonation || !changedDonationInput ? "hide" : ""}`}
                  >
                    {minimumPriceDonation} {currencyChar}{minimalPrice}
                  </span>
                </div>
                {forteam &&
                  <>
                    <div className={'help-bysol'}>
                      <span>{donationForTeam}</span>
                      <p>
                        {donationForTeamText}
                      </p>
                      <select
                        className={'select select-gratuity'}
                        disabled={!validDonation}
                        onChange={(e) => setGratuity(e.target.value)}
                        defaultValue={gratuity}
                      >
                        {gratuitiesOptions.map((gr, index) => {
                          return <option
                            // selected={gr.value === gratuity}
                            key={index}
                            value={gr.value}
                          >
                            {gr.value === 0 
                              ? gr.label 
                              : `${gr.label} (${currencyChar}${Math.floor(donation / 100 * gr.value)})`}
                          </option>
                        })}
                      </select>
                    </div> 
                    <div className={'check-pay'}>
                      <span className={'check-pay-title'}>{checkTitle}</span>
                      <div className={'check-pay-items'}>
                        <div className={'item'}>
                          <span>{checkItemsDonation}</span>
                          <span>{currencyChar} {donation}</span>
                        </div>
                        <div className={'item'}>
                          <span>{checkItemsHelpDonation}</span>
                          <span>{currencyChar} {Math.floor(donation / 100 * gratuity)}</span>
                        </div>
                        <div className={'total-check'}>
                          <span>{checkTotal}</span>
                          <span>{currencyChar} {donation + Math.floor(donation / 100 * gratuity)}</span>
                        </div>
                      </div>
                    </div>
                  </>
                }
                {/* {!forteam && withSub && ( */}
                  <div className={'total-charge-container'}>
                    <div className={`total-charge`}>
                      <span>{checkTotal}</span>
                      <span>{currencyChar} {donation} {modePayment === "subscription" 
                        ? `/ ${totalChargeMonthText}*` 
                        : ""}
                      </span>
                    </div>
                    <span 
                      className={`text-cancel-subscription ${modePayment !== "subscription" ? "hide" : ""}`}
                    >
                      {totalChargeModeSupscription}
                    </span>
                  </div>
                {/* )} */}
              </div>
            </div>
            <button 
              disabled={!isSubmit || loading} 
              className={'btn confirm-btn'} 
              onClick={viewPreview 
                ? () => {
                  setLoading(true);
                  onPriceSubmit({donation, currency, mode: modePayment});
                }
                : () => setViewPreview(true)
              }
            >
              <span>{loading ? confirmButtonSubmitLoading : submit}</span>
            </button>
            {showSB && (
              <img 
                className={'stripe-card'}
                src="data:image/png;base64,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"
              />
            )}
        </Wrapper>
    )
};

export default withNamespaces()(DonationFormV2);